import { Dayjs } from 'dayjs';
import { DefaultDictionary } from '@/app/api/types';

export type WatchedFormValues = [
  recourseType: string,
  factorDealAmount: string,
  factorDiscount: string,
  factorPaymentAmount: string,
  factorPaymentDate: Dayjs | null,
  comissionCalculationTypeId: DefaultDictionary<'id'> | null,
  isTripartiteContract: boolean,
  factoringContractNumber: string,
  factoringContractDate: string | Dayjs | null,
  registerOfDebtsNumber: string,
  registerOfDebtsDate: string | Dayjs | null
];

const isValidDate = (date: string | Dayjs | null | undefined): boolean => {
  if (!date) return false;
  if (typeof date === 'string') {
    return date.trim().length > 0;
  }
  return date !== null;
};

const checkBaseFields = (
  recourseType: string,
  factorDealAmount: string,
  factorDiscount: string,
  factorPaymentAmount: string,
  factorPaymentDate: Dayjs | null,
  comissionCalculationTypeId: DefaultDictionary<'id'> | null
): boolean => {
  return !!(
    recourseType &&
    factorDealAmount &&
    factorDiscount &&
    factorPaymentAmount &&
    factorPaymentDate &&
    comissionCalculationTypeId?.id
  );
};

export const checkContractFieldsFilled = (
  values: WatchedFormValues
): boolean => {
  const [
    recourseType,
    factorDealAmount,
    factorDiscount,
    factorPaymentAmount,
    factorPaymentDate,
    comissionCalculationTypeId,
    ,
    factoringContractNumber,
    factoringContractDate,
  ] = values;

  return !!(
    checkBaseFields(
      recourseType,
      factorDealAmount,
      factorDiscount,
      factorPaymentAmount,
      factorPaymentDate,
      comissionCalculationTypeId
    ) &&
    factoringContractNumber &&
    isValidDate(factoringContractDate)
  );
};

export const checkDebtRegistryFieldsFilled = (
  values: WatchedFormValues
): boolean => {
  const [
    recourseType,
    factorDealAmount,
    factorDiscount,
    factorPaymentAmount,
    factorPaymentDate,
    comissionCalculationTypeId,
    ,
    ,
    ,
    registerOfDebtsNumber,
    registerOfDebtsDate,
  ] = values;

  return !!(
    checkBaseFields(
      recourseType,
      factorDealAmount,
      factorDiscount,
      factorPaymentAmount,
      factorPaymentDate,
      comissionCalculationTypeId
    ) &&
    registerOfDebtsNumber &&
    isValidDate(registerOfDebtsDate)
  );
};
